const eligibilityCheckDictionary = {
  getForm: () => `api/v1/product/get-data`,
  getCourses: () => "api/v1/user-course/get-courses",
  //getCountries: () => "api/v1/user-course/get-countries",
  getCountries: () => "api/v1/master/countries",
  getUniversities: () => "api/v1/user-course/get-universities",
  getInstitutes: () => "api/v1/user-course/get-institutes",
  getMasters: () => "api/v1/user-course/get-master-data",
  getApplicantDetails: (payload: any) => `api/v1/account-aggregator/consent-numbers?trackingId=${payload?.trackingId}`,
  getProducts: () => "api/v1/user-course/get-products",
  dedupeCheck: () => "api/v1/user-course/dedupe-check",
  captureFormData: () => "api/v1/user-course/capture",
  sendOtp: () => "api/v1/user-lead/send-otp",
  checkConsent: () => "api/v1/assisted/check-consent",
  sendConsentOtp: () => "api/v1/assisted/send-otp",
  resendConsentOtp: () => "api/v1/assisted/resend-otp",
  verifyConsentOtp: () => "api/v1/assisted/verify-otp",
  verifyOtp: (type: "mobile" | "email") =>
    `api/v1/user-lead/verify-otp/${type}`,
  checkOffer: () => "api/v1/user-lead/check-eligibility",
  createPartnerLead: () => "api/v1/user-lead/create-lead",
  leadAllocation: () => "api/v1/user-lead/assign-sm",
  partnerGetLeadDetails: () => "api/v1/partner/get-lead-details",
  getMandatoryDocuments: () =>
    `api/v1/journey-master-document/mandatory-documents`,
  getDocuments: () => `api/v1/partner/get-documents`,
  getDocumentCategories: () => `api/v1/journey-master-document/get-categories`,
  getDocumentList: () => `api/v1/journey-master-document/list`,

  createOtherDocument: () => `api/v1/journey-master-document/create`,

  getViewMandatoryDocuments: (payload: any) =>
    `api/v1/journey-master-document/mandatory-documents?trackingId=${payload?.trackingId}`,
  uploadDocument: () => `api/v1/documents/upload`,
  previewDocument: () => `api/v1/applicant/preview-doc`,
  downloadDocument: () => `api/v1/partner/download-document`,
  previewAggregateDocument: () => `api/v1/account-aggregator/preview-doc`,

  addMoreDocument: () => `api/v1/journey-master-document/add-user-document`,
  getViewBulkDocuments: (trackingId: any) =>
    `api/v1/documents/bulk-uploaded-documents?trackingId=${trackingId}`,
  uploadBulkDocuments: () => `api/v1/documents/bulk-upload`,
  deleteUserDocument: () => `api/v1/documents/delete-docs`,
  triggerLinkToCollectDocuments: () => `api/v1/kyc/send-link`,

  accountAggregatorRequest: () => `api/v1/account-aggregator/consent-request`,
  accountAggregatorRequestConsent: () =>
    `api/v1/account-aggregator/application-details`,

  aaConsentDuration: (trackingId: string) => `api/v1/account-aggregator/consent-duration?trackingId=${trackingId}`,
  saveConsentDuration: () => `api/v1/account-aggregator/consent-duration`,
  consentFIRequest: () => `api/v1/accountAggregator/consentFIReqest`,
  getFIRequest: (sessionId: string, applicationNo: string) => `api/v1/accountAggregator/getFIRequest/${sessionId}?applicationNo=${applicationNo}`,
  fetchBre: () => "api/v1/user-lead/fetch-bre",
  checkOfferProvisional: () => "api/v1/user-lead/check-offer",
  getPinCode: (zipCode: string) => `api/v1/master/pincodes?pinCode=${zipCode}`,
  getZipCode: (zipCode: string) =>
    `api/v1/location/zipcodes?zipCode=${zipCode}`,
  //getZipCode: (zipCode: string) => `api/v1/master/pincodes?pinCode=${zipCode}`,
  getState: (stateCode: string) =>
    `api/v1/location/states?stateCode=${stateCode}`,
  getStatesByCountry: (countryName: string) =>
    `api/v1/location/states-by-country?countryName=${encodeURIComponent(countryName)}`,
  getCitiesByCountryState: (countryName: string, stateName?: string) =>
    `api/v1/location/cities-by-country-state?countryName=${encodeURIComponent(countryName)}${
      stateName ? `&stateName=${encodeURIComponent(stateName)}` : ""
    }`,
  getCity: (cityCode: string) => `api/v1/master/cities?cityCode=${cityCode}`,
  getSalutations: () => `api/v1/master/salutations`,
  getSystemValues: () => `api/v1/master/system-values`,
  getMaritalStatusMaster: () => `api/v1/master/marital-status-master`,
  getNationalityMaster: () => `api/v1/master/nationality-master`,
  // getZipCode: (zipCode: string) =>
  //   `api/v1/location/zipcodes?zipCode=${zipCode}`,
  // getState: (stateCode: string) =>
  //   `api/v1/location/states?stateCode=${stateCode}`,
  // getCity: (cityCode: string) => `api/v1/location/cities?stateCode=${cityCode}`,

  getEntranceExamMaster: () => `api/v1/master/entrance-exam-master`,
  getDesignations: () => `api/v1/master/journey-designation-master`,
  getAddressTypes: () => `api/v1/master/address-type-master`,
  getPropertyTypes: () => `api/v1/master/property-type-master?name=PROPERTY_TYPE`,
  getPropertySubTypes: (propertyTypeCode?: string) =>
    `api/v1/master/property-type-master?name=PROPERTY_SUB_TYPE`,
  pushDocument: () => `api/v1/processio/push-document`,
  bulkDocumentCount: () => `api/v1/documents/bulk-document-count`,
  updateApplicationStatus: (trackingId: string) => `api/v1/user-application/update-application-status?trackingId=${trackingId}`,
  collaterIdGet:(trackingId:string)=>`api/v1/user-application/fetch-collateral/?trackingId=${trackingId}`,
};

export default eligibilityCheckDictionary;
